export const typesRegistrationOptions = [
    {
        value: 'UNIDADE',
        label: 'Unidade'
    },
    {
        value: 'GERENCIA',
        label: 'Gerência'
    },
];

export const goOptions = [
    {
        value: 'GO1',
        label: 'GO1',
    },
    {
        value: 'GO2',
        label: 'GO2'
    },
    {
        value: 'GO3',
        label: 'GO3',
    },
    {
        value: 'GO4',
        label: 'GO4',
    },
];

export const porteOptions = [
    {
        value: 'P',
        label: 'P'
    },
    {
        value: 'P_MAIS',
        label: 'P+'
    },
    {
        value: 'M',
        label: 'M',
    },
    {
        value: 'M_MAIS',
        label: 'M+'
    },
    {
        value: 'G',
        label: 'G'
    },
    {
        value: 'G_MAIS',
        label: 'G+',
    },
    {
        value: 'NUCLEO',
        label: 'Núcleo'
    },
];